import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import {useSelector} from 'react-redux'
import Checkbox from './form/Checkbox'
import CommentModal from '#components/m/CommentModal'
import Tooltip from '#components/m/Tooltip'
import Text from './Text'
import Lock from '#components/svg/icons/Lock'
import IconButton from '#components/a/IconButton'

export default function EditableTask({
  task: {done, text, id, kommentar, deletable, abteilungId},
  canOnlyEditOwnAbteilungen,
  backgroundColor,
  onDelete,
  postComment,
}) {
  const renderCommentModalForAusbilder = () => {
    const hasComment = kommentar !== undefined

    return (
      <CommentModal
        trigger={<div className={hasComment ? 'task__comment task__comment--active' : 'task__comment'} />}
        confirmCallback={commentText => postComment(id, commentText)}
        commentText={hasComment ? kommentar.text : ''}
        placeholder={i18n.t('praxisaufgaben_feedback_placeholder')}
        confirmText={i18n.t('praxisaufgaben_feedback_button')}
      />
    )
  }

  const renderLockTooltipBecauseRequired = () => (
    <Tooltip
      className="tooltip__lock"
      trigger={<Lock color={backgroundColor} />}
      modifier="dark small"
      placement="bottom"
      triggerAction="hover">
      <Text modifier="in-tooltip" text={i18n.t('status_undeletable_aufgabe_tooltip')} />
    </Tooltip>
  )

  const renderLockTooltipBecauseDifferentFachabteilung = () => (
    <Tooltip
      className="tooltip__lock"
      trigger={<Lock color={backgroundColor} />}
      modifier="dark small"
      placement="bottom"
      triggerAction="hover">
      <Text modifier="in-tooltip" text={i18n.t('status_aufgabe_from_different_fachabteilung_not_deletable_tooltip')} />
    </Tooltip>
  )

  const abteilungen = useSelector(state => state.authentication.abteilungen)
  const isOwnAbteilung = abteilungen?.includes(abteilungId)
  const taskCanBeDeleted = !done && deletable

  const showDeleteLockBecauseOfFachabteilung = canOnlyEditOwnAbteilungen && !isOwnAbteilung && taskCanBeDeleted
  const showDeleteLockBecauseTaskIsRequired = !deletable && !done

  const showTrashcan = taskCanBeDeleted && !showDeleteLockBecauseOfFachabteilung && !showDeleteLockBecauseTaskIsRequired

  const styleBorder = !deletable ? {borderLeft: `solid ${backgroundColor} 5px`} : {}

  return (
    <div className={done ? 'task task--done' : 'task'} style={styleBorder}>
      <Checkbox modifier="disabled" disabledState checked={done} labelText={text} />
      {showTrashcan && <IconButton event={onDelete} className="task__delete" icon="delete" />}
      {showDeleteLockBecauseTaskIsRequired && renderLockTooltipBecauseRequired()}
      {showDeleteLockBecauseOfFachabteilung && renderLockTooltipBecauseDifferentFachabteilung()}
      {done && renderCommentModalForAusbilder()}
    </div>
  )
}

EditableTask.propTypes = {
  task: PropTypes.shape({
    text: PropTypes.string,
    done: PropTypes.bool,
    deletable: PropTypes.bool,
    id: PropTypes.string.isRequired,
    kommentar: PropTypes.object,
    abteilungId: PropTypes.number.isRequired,
  }).isRequired,
  onDelete: PropTypes.func,
  postComment: PropTypes.func,
  backgroundColor: PropTypes.string,
  canOnlyEditOwnAbteilungen: PropTypes.bool,
}
